import { useTranslation } from '@/i18n';
import {
  ButtonGroup,
  ButtonV2,
  Tooltip,
} from '@moneyforward/ap-frontend-components';
import { FC, useMemo } from 'react';

type Props = {
  onCancel: VoidFunction;
  onSelected: VoidFunction;
  disabled: boolean;
  notSatisfiedScanner: boolean;
};

export const Footer: FC<Props> = ({
  onCancel,
  onSelected,
  disabled,
  notSatisfiedScanner,
}) => {
  const { t } = useTranslation();

  const selectButton = useMemo(
    () => (
      <ButtonV2
        isDisabled={disabled}
        size='md'
        color='primary'
        onClick={onSelected}
      >
        {t('selected')}
      </ButtonV2>
    ),
    [disabled, onSelected, t]
  );

  return (
    <ButtonGroup>
      <ButtonV2 size='md' color='primary' isSecondary onClick={onCancel}>
        {t('cancel')}
      </ButtonV2>
      {notSatisfiedScanner ? (
        <Tooltip
          title={t('invoice_reports.scanner_save_requirement_not_satisfied')}
          // eslint-disable-next-line @moneyforward/account-payable/literals-in-props
          align={{
            overflow: { adjustX: true },
          }}
        >
          {selectButton}
        </Tooltip>
      ) : (
        selectButton
      )}
    </ButtonGroup>
  );
};
